/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 共通管理フラグ - USER:ユーザ - COMMON: 標準 - BLANK: 未設定 
 * @export
 * @enum {string}
 */

export const CommonManagementNotRequiredFlag = {
    User: 'USER',
    Common: 'COMMON',
    Blank: 'BLANK'
} as const;

export type CommonManagementNotRequiredFlag = typeof CommonManagementNotRequiredFlag[keyof typeof CommonManagementNotRequiredFlag];



